import { Injectable } from '@angular/core';
import {SessionsService} from './sessions.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private session: SessionsService
  ) { }

  public isSignedInUser() {
    return !!this.session.getAccessTokenUser()
  }

  public isSignedInAdmin() {
    return !!this.session.getAccessTokenAdmin()
  }

  public doSignOutUser() {
    this.session.destroyUser();
  }

  public doSignOutAdmin() {
    this.session.destroyAdmin();
  }

  public doSignInUser(accessToken: string, name: string) {
    if ((!accessToken) || (!name)) {
      return;
    }
    this.session.registerSessionUser(accessToken, name);
  }

  public doSignInAdmin(token: string) {
    this.session.registerSessionAdmin(token);
  }
}
